/** Static i18n keys for /anmalning/prova-svar (avoid dynamic keys + API English copy). */

export const TRIAL_FOLLOWUP_KINDS = [
  "accepted",
  "already_member",
  "declined",
  "already",
  "expired",
  "invalid",
  "account_error",
  "banned",
  "error",
];

export const TRIAL_FOLLOWUP_COPY_KEYS = {
  accepted: {
    heading: "anmalningar_trial_followup_accepted_heading",
    message: "anmalningar_trial_followup_accepted_message",
  },
  already_member: {
    heading: "anmalningar_trial_followup_already_member_heading",
    message: "anmalningar_trial_followup_already_member_message",
  },
  declined: {
    heading: "anmalningar_trial_followup_declined_heading",
    message: "anmalningar_trial_followup_declined_message",
  },
  already: {
    heading: "anmalningar_trial_followup_already_heading",
    message: "anmalningar_trial_followup_already_message",
  },
  expired: {
    heading: "anmalningar_trial_followup_expired_heading",
    message: "anmalningar_trial_followup_expired_message",
  },
  invalid: {
    heading: "anmalningar_trial_followup_invalid_heading",
    message: "anmalningar_trial_followup_invalid_message",
  },
  account_error: {
    heading: "anmalningar_trial_followup_account_error_heading",
    message: "anmalningar_trial_followup_account_error_message",
  },
  banned: {
    heading: "anmalningar_trial_followup_banned_heading",
    message: "anmalningar_trial_followup_banned_message",
  },
  error: {
    heading: "anmalningar_trial_followup_error_heading",
    message: "anmalningar_trial_followup_error_message",
  },
};

export function normalizeTrialFollowupKind(rawKind) {
  const kind = String(rawKind || "").trim();
  if (!kind || kind === "invalid") return "invalid";
  if (TRIAL_FOLLOWUP_KINDS.includes(kind)) return kind;
  return "error";
}

export function trialFollowupCopyForKind(kind, t) {
  const normalized = normalizeTrialFollowupKind(kind);
  const keys = TRIAL_FOLLOWUP_COPY_KEYS[normalized] || TRIAL_FOLLOWUP_COPY_KEYS.error;
  return {
    kind: normalized,
    heading: t(keys.heading),
    message: t(keys.message),
  };
}
